(function () {
  'use strict';

  function formatMoney(cents, currency) {
    if (window.Currency && typeof window.Currency.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Currency.formatMoney(cents, window.theme.moneyFormat);
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'CAD'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function buildReturnTo(productUrl, variantId, alertId) {
    return productUrl + '?variant=' + variantId + '#' + alertId;
  }

  function initializeRestockAlert(alert) {
    if (!alert || alert.dataset.restockInitialized === 'true') {
      return;
    }

    alert.dataset.restockInitialized = 'true';

    var productSection = alert.closest('[data-section-type="product"]');
    var form = alert.querySelector('form');
    var initialVariantElement = alert.querySelector('[data-restock-initial-variant]');
    var tagInput = alert.querySelector('[data-restock-tags]');
    var priceElements = alert.querySelectorAll('[data-restock-price]');
    var titleElements = alert.querySelectorAll('[data-restock-variant-title]');
    var submitButton = alert.querySelector('[data-restock-submit]');
    var returnToInput = form ? form.querySelector('input[name="return_to"]') : null;
    var currentVariant = null;

    if (initialVariantElement) {
      try {
        currentVariant = JSON.parse(initialVariantElement.textContent);
      } catch (error) {
        currentVariant = null;
      }
    }

    function update(variant) {
      if (!variant) {
        alert.hidden = true;
        return;
      }

      currentVariant = variant;
      alert.hidden = Boolean(variant.available);

      if (variant.available) {
        return;
      }

      var variantTitle = variant.title === 'Default Title' ? alert.dataset.productTitle : variant.title;
      var timestamp = Math.floor(Date.now() / 1000);

      titleElements.forEach(function (element) {
        element.textContent = variantTitle;
      });

      priceElements.forEach(function (element) {
        element.textContent = formatMoney(variant.price, alert.dataset.currency);
      });

      if (tagInput) {
        tagInput.value = [
          'restock-alert',
          'restock-variant-' + variant.id,
          'restock-price-' + variant.id + '-' + timestamp + '-' + variant.price
        ].join(',');
      }

      if (returnToInput) {
        returnToInput.value = buildReturnTo(alert.dataset.productUrl, variant.id, alert.id);
      }
    }

    if (productSection) {
      productSection.addEventListener('variant:changed', function (event) {
        update(event.detail && event.detail.variant);
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        update(currentVariant);

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Registering...';
        }
      });
    }

    update(currentVariant);
  }

  function initializeWithin(container) {
    if (container && container.matches && container.matches('[data-restock-alert]')) {
      initializeRestockAlert(container);
    }

    if (container && container.querySelectorAll) {
      container.querySelectorAll('[data-restock-alert]').forEach(initializeRestockAlert);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
